import $ from 'jquery';

import { onlyUnique } from 'lib/util/array';

const devMode = !!(window.location.search + window.location.hash).match(/\bdevconsole\b/);

export const enum CFU {
	RES = 'res', // Residential
	SME = 'sme', // Small Business
	CBU = 'cbu', // Enterprise (ENT)
}

export interface UserData {
	cust_scn : string;
	cust_fname : string;
	cust_lname : string;
	cust_segment : CFU;
	session_authlevel : string;
	user_roles : string;
}

export class User {
	constructor(private data : UserData) {}

	public getId() {
		return this.data.cust_scn;
	}

	public getFirstName() {
		return decodeURIComponent(this.data.cust_fname || '');
	}

	public getLastName() {
		return decodeURIComponent(this.data.cust_lname || '');
	}

	public getAuthLevel() {
		return decodeURIComponent(this.data.session_authlevel || '');
	}

	/**
	 * Get full name (first and last)
	 */
	public getFullName() {
		if (this.isSegmentSme() || this.isSegmentCbu()) {
			// We only use the last name in this case, which contains the company name.
			return this.getLastName();
		}

		return [
			this.getFirstName(),
			this.getLastName(),
		]
			.filter(Boolean)
			.filter(onlyUnique)
			.join(' ');
	}

	public getSegment() {
		return this.data.cust_segment || CFU.RES;
	}

	public isSegmentSme() {
		return this.getSegment() === CFU.SME;
	}

	public isSegmentCbu() {
		return this.getSegment() === CFU.CBU;
	}

	public isSegmentRes() {
		return this.getSegment() === CFU.RES;
	}
}

export class Profile {
	constructor(private user? : User) {}

	public getUser() {
		return this.user;
	}
}

const KEY = 'scsHeader.profile.loginData';

// FIXME: Use OCE MiSe
async function fetchProfile() {
	try {
		const contents = await new Promise<any>((resolve, reject) => {
			$.get('/etc/profile.json').done(resolve).fail(reject);
		});

		if(KEY in contents) {
			// KEY existing means this is a logged-in user
			return new Profile(new User(contents[KEY]));
		}
	} catch(e) {
		if(devMode) {
			console.error('Profile JSON data not in expected format', e);
		}

		return new Profile();
	}

	// User not logged in
	return new Profile();
}

let profile : Promise<Profile> | undefined;
export function getProfile() : Promise<Profile> {
	if(!profile) {
		profile = fetchProfile();
	}

	return profile;
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/personalization/profile.ts